import styled from 'styled-components';

import { Modal } from '@dreryk/react-components';

export const StyledNfzMfaModal = styled(Modal)`
   [data-testcomponent='Footer'] {
      display: none;
   }
` as typeof Modal;
